const formatPhoneNumbers = (phone) => {
    if (!phone) return null;
    
    // Rimuovi gli spazi
    let formattedPhone = phone.replace(/\s+/g, '');
    
    // Rimuovi il prefisso +39 se presente
    if (formattedPhone.startsWith('+39')) {
      formattedPhone = formattedPhone.slice(3);
    }
    
    return formattedPhone;
  };
  
  export default formatPhoneNumbers;
  